import React from "react";
import "../assets/css/studentdashboard.css";

const StudentInfoCard = ({ student }) => {
  return (
    <div className="student-info-card">
      <div className="student-header">
        <img src={student.photo} alt="Student" className="student-photo" />
        <div className="student-name">
          <h2>{student.name}</h2>
          <p className="matric-no">{student.matricNo}</p>
        </div>
        {/* <button className="edit-profile-btn">Edit Profile</button> */}
      </div>
      <table className="student-info-table">
        <tbody>
          <tr>
            <td>Matriculation No:</td>
            <td>{student.matricNo}</td>
          </tr>
          <tr>
            <td>Faculty:</td>
            <td>{student.faculty}</td>
          </tr>
          <tr>
            <td>Department:</td>
            <td>{student.department}</td>
          </tr>
          <tr>
            <td>Programme:</td>
            <td>{student.programme}</td>
          </tr>
          <tr>
            <td>Level:</td>
            <td>{student.level}</td>
          </tr>
          <tr>
            <td>Session:</td>
            <td>{student.session}</td>
          </tr>
          <tr>
            <td>Entry Mode:</td>
            <td>{student.entryMode}</td>
          </tr>
          <tr>
            <td>Entry Year:</td>
            <td>{student.entryYear}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default StudentInfoCard;
